<template>
  <RootModalComponent
    :name="$MODAL_NAME.ADD_TAGS"
    icon="ri-coupon-3-line"
    :title="'d_ws_add_tags' | translate"
    width="512"
    :footer="modalFooter"
    @add="save"
    @beforeOpen="beforeOpen"
    @closed="closed"
    :mobile-type="$MODAL_TYPE_MOBILE.FULL"
    :frame="true"
  >
    <div class="tags-modal">
      <div class="tags-modal__inner">
        <CheckboxList :list="tags" @change="onTagsAdd" />
      </div>
    </div>
  </RootModalComponent>
</template>

<script>

import RootModalComponent from './RootModalComponent'
import Dropdown from '../controls/Dropdown'
import CheckboxList from '../controls/CheckboxList'

export default {
  components: {
    RootModalComponent,
    Dropdown,
    CheckboxList
  },
  data() {
    return {
      currentTags: [],
      tags: [],
      modalFooter: {
        lineTop: false,
        items: [
          {
            type: 'secondary',
            action: 'closed',
            title: 'd_ws_button_cancel'
          },
          {
            type: 'primary',
            action: 'add',
            title: 'd_ws_button_save'
          }
        ]
      }
    }
  },
  methods: {
    beforeOpen() {
      this.tags = this.$tagsService.getTicketTags();
    },
    closed() {
      this.$modal.hide(this.$MODAL_NAME.ADD_TAGS)
    },
    onTagsAdd(tags) {
      this.currentTags = tags.filter(tag => tag.checked)
    },
    save() {
      this.$store.currentTicketTags = this.currentTags;
      this.$modal.hide(this.$MODAL_NAME.ADD_TAGS)
    }
  }
}
</script>

<style lang="scss" scoped>
  .tags-modal {
    &__inner {
      display: flex;
      justify-content: center;
      padding: 24px;
    }
  }

  @media (max-width: 425px) {
    .tags-modal {
      &__inner {
        justify-content: flex-start;
        padding: 18px 16px;
      }
    }
  }
</style>
